var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A09C8A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5104,18.6104c-3.3234,3.3234-8.7681,3.2527-12.0208,0s-3.3234-8.6974,0-12.0208s8.7681-3.2527,12.0208,0 S21.8338,15.287,18.5104,18.6104z M7.3381,7.4381c-2.8284,2.8284-2.8284,7.4953,0,10.3238s7.4953,2.8284,10.3238,0 s2.8284-7.4953,0-10.3238S10.1665,4.6097,7.3381,7.4381z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2577,11.6808l-1.9092,1.9092c-0.2121,0.2121-0.7071,0.2828-0.9899,0 c-0.2121-0.2121-0.2828-0.7071-0.2828-0.7071l1.9092-1.9092c0.5657-0.5657,0.9192-0.495,1.2021-0.2121 C15.3991,10.9737,15.5406,11.3979,15.2577,11.6808z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1364,13.8021c-0.2121,0.2121-0.7071,0.2828-1.0607-0.0707l-3.0406-3.0406 C8.7523,10.408,8.6816,9.913,8.9645,9.6302c0.2828-0.2828,0.7071-0.2828,1.0607,0.0707l3.0406,3.0406 C13.3485,13.0243,13.3485,13.5899,13.1364,13.8021z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.ac54d940d72972a12ad21bd1251cce74.svg";
export { ForwardRef as ReactComponent };